import { List, ListItemButton } from '@mui/material';

export default function ParentCoop({ parent_coop = {} }) {
  const text = parent_coop.saradnja_sa_roditeljima;

  return (
    <div>
      <div className="marks-container">
        <List sx={{ p: 0, m: 0 }}>
          <ListItemButton sx={{ p: 0, m: 0 }}>
            <div className="main-flex-container">
              <div className="right-flex-container">
                <div className="bottom-flex-container w-100" style={{ marginTop: 5 }}>
                  <div className="prewrap">{text}</div>
                </div>
              </div>
            </div>
          </ListItemButton>
        </List>
      </div>
    </div>
  );
}
